import { render, staticRenderFns } from "./RegionTab.vue?vue&type=template&id=fa6c860e&"
import script from "./RegionTab.vue?vue&type=script&lang=js&"
export * from "./RegionTab.vue?vue&type=script&lang=js&"
import style0 from "./RegionTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports